<template>
  <b-modal :id="`unable-checkin${id}`" modal-class="modal-style" ref="modal">
    <template>
      <p class="modal-style-title alert-title">無法報到上課</p>
      <div class="modal-style-content">
        <p>尚有欠費未繳清，無法報到上課</p>
      </div>
    </template>

    <template v-slot:modal-footer>
      <button class="custom-btn modal-style-single-btn" @click="closeModal()">
        確定
      </button>
    </template>
  </b-modal>
</template>

<script>
export default {
  props: {
    id: {
      required: true,
      type: Number
    }
  },
  data() {
    return {
      modal: false
    };
  },
  watch: {
    modal(next) {
      if (next == false) {
        this.$emit('closeModal');
      }
    }
  },
  methods: {
    closeModal() {
      this.$bvModal.hide(`unable-checkin${this.id}`);
    }
  }
};
</script>
